
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./graphql-python-5-links-and-voting.json") })
        }
      }, "path---graphql-python-5-links-and-voting");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---graphql-python-5-links-and-voting!./.cache/json/graphql-python-5-links-and-voting.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---graphql-python-5-links-and-voting!./.cache/json/graphql-python-5-links-and-voting.json
// module chunks = 154